var ctrlopt = ctrlopt,
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var city_dropdown_enabled =
    Drupal.settings.globals_variables.show_city_drop_down_apptbk !== 'undefined'
      ? Drupal.settings.globals_variables.show_city_drop_down_apptbk
      : 0;
  var settings = Drupal.settings.globals_variables || {};
  var oabCounterNameOnly = settings.oabCounterNameOnly || 0;

  /* Concrete View */
  apptBook.LocationSelectSection = function (container) {
    apptBook.LocationSelectSection.superclass.constructor.call(this);
    this.id = 'counters';
    this.container = container;
    this.selectMenu = container.find('select.location-select');
    this.cityMenu = container.find('select.city-select');
    this.submitBtn = container.find('.location-submit');
    this.signinMessage = container.find('.appt-book-location__signin-text');
    this.boundTransIn = this.onTransIn.bind(this);
    this.initialized = false;
    this.stores = {};
  };

  ctrlopt.extend(apptBook.LocationSelectSection, apptBook.AbstractSection);

  apptBook.LocationSelectSection.prototype.buildCityMenu = function () {
    var me = this;

    if (!this.cityMenu.length) {
      return;
    }
    var optionText = [],
      uniqueCityVals = [];

    for (var i = 0, len = this.countersData.length; i < len; i += 1) {
      optionText[i] = this.countersData[i].town;
    }
    $.each(optionText, function (i, el) {
      if ($.inArray(el, uniqueCityVals) === -1) {
        uniqueCityVals.push(el);
        var newOption = $('<option value="' + el + '">' + el + '</option>');

        me.cityMenu.append(newOption);
      }
    });
    $(this.cityMenu).on('change', function () {
      $(me.selectMenu).find('option').not(':first').remove();
      var select_text = $(me.selectMenu).find('option').html();

      $('ul.location-select-selectBox-dropdown-menu li').not(':first').remove();
      $('ul.location-select-selectBox-dropdown-menu').append(
        '<li class="selectBox-selected">' + '<a rel="' + 0 + '">' + select_text + '</a>' + '</li>'
      );
      me.buildSelectMenu();
      $(me.selectMenu).selectBox('refresh');
      if (this.value === '0' || $(me.selectMenu).val() === '0') {
        me.submitBtn.addClass('disabled');
      } else {
        me.submitBtn.removeClass('disabled');
      }
    });
  };

  apptBook.LocationSelectSection.prototype.buildSelectMenu = function () {
    var me = this;

    if (!this.countersData || !this.selectMenu.length) {
      return;
    }

    var selected_city =
      $(this.cityMenu) && $(this.cityMenu).val() != '0' ? $(this.cityMenu).val() : 0;

    for (var i = 0, len = this.countersData.length; i < len; i += 1) {
      if (!selected_city || (city_dropdown_enabled && selected_city == this.countersData[i].town)) {
        var storeName = this.countersData[i].name;
        var optionText;

        if (city_dropdown_enabled) {
          optionText = storeName + ', ' + this.countersData[i].address1;
        } else if (oabCounterNameOnly) {
          optionText = storeName;
        } else {
          optionText =
            this.countersData[i].town + ' - ' + storeName + ', ' + this.countersData[i].address1;
        }
        var optionValue = this.countersData[i].id,
          newOption = $('<option value="' + optionValue + '">' + optionText + '</option>'),
          ul_newOption = $(
            '<li>' + '<a rel="' + optionValue + '">' + optionText + '</a>' + '</li>'
          ),
          storeNum = this.countersData[i].store_no;

        this.stores[optionValue] = {
          store: storeNum,
          name: storeName
        };

        // Don't filter out counters
        this.selectMenu.append(newOption);
        $('ul.location-select-selectBox-dropdown-menu').append(ul_newOption);

        // filter out counters with no services and counters with no calendars
        /* if (this.countersData[i].service_ids.length > 0 && this.countersData[i].calendars.length > 0) {
        this.selectMenu.append(newOption);
      }*/
      }
    }

    this.selectMenu.on('change', function (e) {
      var condition = this.value === '0';

      if (me.cityMenu.length) {
        var condition = this.value === '0' || $(me.cityMenu).val() === '0';
      }
      if (condition) {
        me.submitBtn.addClass('disabled');
      } else {
        me.submitBtn.removeClass('disabled');
      }
    });
  };

  apptBook.LocationSelectSection.prototype.setSubmitHandler = function () {
    var me = this;

    function onSubmit(e) {
      var updateData,
        select = me.selectMenu[0],
        counterId = select.options[select.selectedIndex].value;

      e.preventDefault();

      if ($(this).hasClass('disabled')) {
        return;
      }
      Drupal.behaviors.apptBook.setVirtual('virtual_oab', 0);
      if (counterId) {
        site.track.evtLink({
          event_name: 'appointmentBooking_Location',
          event_category: 'appointment booking',
          event_action: 'location chosen',
          event_label: me.stores[counterId].store + ' - ' + me.stores[counterId].name
        });

        updateData = {
          sectionId: 'next',
          params: {
            sectionId: me.id,
            counterId: counterId,
            updateMode: me.updateMode
          }
        };
        me.model.update(updateData);
      }
    }

    this.submitBtn.click(onSubmit);
  };

  apptBook.LocationSelectSection.prototype.onTransIn = function () {
    var sBoxes = this.container.find('.selectbox, .selectBox');

    Drupal.ELB.refreshSelectBoxes(sBoxes);
  };

  apptBook.LocationSelectSection.prototype.onUpdate = function (data) {
    var me = this,
      aPgName = document.title + ' - Location Select';

    if (data.sectionId === this.id) {
      apptBook.sectionManager.on('transition_in_start', this.boundTransIn);

      me.isSignedIn =
        typeof site.userInfoCookie == 'undefined' ||
        site.userInfoCookie.getValue('signed_in') == null
          ? 0
          : site.userInfoCookie.getValue('signed_in');

      if (data.params.updateMode) {
        this.updateMode = true;
      } else {
        this.updateMode = false;
      }
      if (!this.initialized) {
        this.initialized = true;
        this.model.getCounters(function (cData) {
          var virtualList = [],
            virtualIds;

          me.countersData = [];
          for (var j = 0; j < me.model.servicesData.length; j += 1) {
            if (me.model.servicesData[j].virtual !== '0') {
              virtualList.push(me.model.servicesData[j].id);
            }
          }
          for (var i = 0; i < cData.length; i++) {
            virtualIds = virtualList.filter(function (e) {
              return cData[i].service_ids.indexOf(e) !== -1;
            });
            if (!virtualIds.length) {
              me.countersData.push(cData[i]);
            }
          }
          me.buildSelectMenu();
          if (city_dropdown_enabled) {
            me.buildCityMenu();
          }
          if (me.isSignedIn > 0) {
            me.signinMessage.hide();
          }
          me.setSubmitHandler();
        });
      }
    } else {
      apptBook.sectionManager.off('transition_in_start', this.boundTransIn);
    }
  };

  Drupal.behaviors.apptBookLocation = {
    attach: function (context) {
      var view = new apptBook.LocationSelectSection($('#counters')),
        self = this;

      self.setVirtual('virtual_oab', 0);
      view.setModel(apptBook.sectionModel).startObserving();
      $('.js-virtual-service-message').addClass('hidden');

      $('.js-virtual__appointment--button').on('click', function () {
        site.track.evtLink({
          event_name: 'appointmentbooking',
          event_category: 'appointment booking',
          event_action: 'start',
          event_label: 'video appointment'
        });
        var storeNumber = $('.appt-book-location-selector').attr(
          'data-virtual_store_querystring_value'
        );

        if ($(this).hasClass('no_services')) {
          $('.js-virtual-service-message').removeClass('hidden');
        }
        self.setVirtual('virtual_oab', 1);
        apptBook.jumpToServicesForStore(storeNumber);
      });
    },
    setVirtual: function (key, value) {
      localStorage.setItem(key, value);
    }
  };
})(jQuery);
